import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/checklist-runs')({
  component: () => <Outlet />,
})
